export default "__VITE_ASSET__DVC14WYB__"